<script setup>
import { useForm } from '@inertiajs/vue3';
import ActionMessage from '@/Components/ActionMessage.vue';
import FormSection from '@/Components/FormSection.vue';
import InputLabel from '@/Components/InputLabel.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';

const props = defineProps({
    customers: Array,
    currentCustomerId: [Number, String, null],
});

const form = useForm({
    customer_id: props.currentCustomerId ?? '',
});

const submit = () => {
    form.put(route('profile.update-customer'), {
        preserveScroll: true,
    });
};
</script>

<template>
    <FormSection @submitted="submit">
        <template #title>
            Cliente per demo super amministratore
        </template>

        <template #description>
            Seleziona il cliente da caricare di default come super amministratore per le demo.
        </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <InputLabel for="customer_id" value="Cliente" />
                <select
                    id="customer_id"
                    v-model="form.customer_id"
                    class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                    <option value="">Scelto al login</option>
                    <option v-for="customer in customers" :key="customer.id" :value="customer.id">
                        {{ customer.name }}
                    </option>
                </select>
            </div>
        </template>

        <template #actions>
            <ActionMessage :on="form.recentlySuccessful" class="me-3">
                Cliente aggiornato.
            </ActionMessage>

            <PrimaryButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Cambia cliente
            </PrimaryButton>
        </template>
    </FormSection>
</template>
